import React from 'react';
import SkeletonComponent from './common/SkeletonComponent.jsx';

const ProjectWorkspaceSkeleton = () => {
  return (
    <div className='project-workspace-container' style={{height: '100vh'}}>
      <h2 style={{height: 42, marginTop: 6}}>
        <SkeletonComponent variant='text' height={26} width='100%' />
      </h2>
      <div>
        <SkeletonComponent variant='rounded' height={390} width='100%' />
      </div>
      <div className='pt-2'>
        <SkeletonComponent height={800} width='100%' />
      </div>
    </div>
  )
}

export default ProjectWorkspaceSkeleton;